import { getRestrictionFilters } from '@/helpers/search';

export default {
  computed: {
    restrictionFilterKeys() {
      if (!this.state('search')) return [];
      const defaultStockScope = this.getters('search/getDefaultScope');
      return getRestrictionFilters(defaultStockScope);
    },
  },
  methods: {
    /**
     * Check if the corresponding filter has more than 1 item
     * @param {String - required} name
     * @returns boolean
     */
    checkFilter(name) {
      const filter = this.state(`search.filtersOptions.${name}`);
      if (!filter) return false;

      const filterItems = filter.items;

      if (!filterItems || (filterItems && filterItems.length === 0)) return false;

      const refinedFilterValues = filterItems.filter((f) => f.count > 0);
      return refinedFilterValues.length > 1;
    },
    /**
     * Check if the filter belongs to sectionCustomQuery, siteCustomQuery
     * @param {*} name filter name
     * @returns boolean
     */
    isRestrictionFilter(name) {
      if (!name) return false;
      return this.restrictionFilterKeys.indexOf(name) > -1;
    },
  },
};
